import { render, staticRenderFns } from "./fcLetter.vue?vue&type=template&id=0a8dae64&"
import script from "./fcLetter.vue?vue&type=script&lang=js&"
export * from "./fcLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports